import Api from 'src/api/Base'

class GetSpacePlanClustersAssignment extends Api {
  requestUrl = `/api/SpacePlan/${this.getParams().spacePlanId}/ClusterSpaceAssignments?spaceId=${
    this.getParams().spaceId
  }`
}

export default GetSpacePlanClustersAssignment
